<template>
  <page-wrapper :title="title">
    <div v-if="!$isCallCenter" class="header">
      <sc-button
        :route="{ name: 'ServiceCreatePage' }"
        class="create-button"
        variant="primary"
        >เพิ่มบริการ</sc-button
      >
      <sc-button
        :route="{ name: 'MultipleServiceUnavailableDatePage' }"
        variant="secondary"
        >ลงวันไม่ว่างของหลายบริการ</sc-button
      >
    </div>
    <div class="container-fluid filter-form">
      <div class="row ms-3 me-3 pt-3">
        <div class="mb-3">
          <br />
          <el-radio
            v-model="query.filterType"
            :label="filterToType.NORMAL"
            @change="handleChangeFilterType()"
            >&nbsp;</el-radio
          >
        </div>
        <div class="col-lg-3 mb-3">
          <label class="search-service">ชื่อบริการ</label>
          <el-input
            v-model="query.name"
            :disabled="query.filterType === filterToType.UNAVAILABLE"
          ></el-input>
        </div>
        <div class="col-lg-2 mb-3">
          <label class="search-service">ผู้ให้บริการ</label>
          <provider-selector
            v-model="selectedProvider"
            :disabled="query.filterType === filterToType.UNAVAILABLE"
          ></provider-selector>
        </div>
        <div>
          <br />
          <el-divider direction="vertical"></el-divider>
        </div>
        <div class="mb-3">
          <br />
          <el-radio
            v-model="query.filterType"
            :label="filterToType.UNAVAILABLE"
            @change="handleChangeFilterType()"
            >&nbsp;</el-radio
          >
        </div>
        <div class="col-lg-3 mb-3">
          <label class="search-service"
            >เลือกประเภทวันที่ไม่สามารถนัดหมายบริการ</label
          >
          <el-select
            v-model="query.filterTypeOfUnavailableDate"
            :disabled="query.filterType === filterToType.NORMAL"
            clearable
            @change="handleChangeFilterTypeOfUnavailableDate()"
          >
            <el-option
              v-for="t in dateType"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
        <div v-if="query.filterTypeOfUnavailableDate" class="col-lg-3 mb-3">
          <div
            v-if="query.filterTypeOfUnavailableDate === dateTypeMapping.MONTH"
          >
            <div class="date-calendar">
              <el-checkbox-group
                v-model="queryByUnavailableDate.unavailableWorkdaysInMonth"
              >
                <el-checkbox-button
                  v-for="date in dateOfMonth"
                  :key="date"
                  :label="date"
                  >{{ date }}</el-checkbox-button
                >
              </el-checkbox-group>
            </div>
          </div>
          <div
            v-else-if="
              query.filterTypeOfUnavailableDate === dateTypeMapping.DATE
            "
          >
            <div>
              <label class="search-service">เลือกวันที่</label>
              <date-picker
                :value="queryByUnavailableDate.unavailableDate"
                @input="handleChangeSelectedUnavailableDate($event)"
              ></date-picker>
            </div>
          </div>
          <div
            v-else-if="
              query.filterTypeOfUnavailableDate === dateTypeMapping.TIME
            "
          >
            <div>
              <label class="search-service">เลือกช่วงเวลา</label>
              <div class="time-calendar">
                <el-checkbox-group
                  v-model="queryByUnavailableDate.unavailableTimes"
                >
                  <el-checkbox-button
                    v-for="time in timeOfDay"
                    :key="time.value"
                    :label="time.value"
                    >{{ time.label }}</el-checkbox-button
                  >
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <div
            v-else-if="
              query.filterTypeOfUnavailableDate === dateTypeMapping.WEEK
            "
          >
            <div>
              <label class="search-service">ทุก ๆ วัน</label>
              <div class="day-calendar">
                <el-checkbox-group
                  v-model="queryByUnavailableDate.unavailableWorkdaysInWeek"
                >
                  <el-checkbox-button
                    v-for="day in daysOfWeek"
                    :key="day.value"
                    :label="day.value"
                    >{{ day.label }}</el-checkbox-button
                  >
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ms-3 me-3 pb-3 text-end">
        <sc-button variant="secondary" @click="handleClickSearchButton"
          >ค้นหา</sc-button
        >
      </div>
    </div>

    <div class="wrapper">
      <div v-if="query.filterType === filterToType.NORMAL" class="container">
        <p class="mb-2 mt-2">{{ totalCount }}</p>
        <service-list-item
          v-for="item in list"
          :key="item.id"
          v-bind="item"
        ></service-list-item>
        <div class="text-end mt-4">
          <el-pagination
            :total="total"
            :page-size="30"
            :current-page="query.page"
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
      <div
        v-if="query.filterType === filterToType.UNAVAILABLE"
        class="container"
      >
        <p class="mb-2 mt-2">
          พบข้อมูลทั้งหมด {{ unavailableDateCount }} บริการ
        </p>
        <div v-if="unavailableDateList.length > 0">
          <div
            v-for="item in unavailableDateList"
            :key="item.id"
            v-bind="item"
            class="service-list-item"
          >
            <img v-if="item.iconUrl" :src="item.iconUrl" class="icon" />
            <div class="col-10 meta no-icon">
              <router-link v-if="item.route" :to="item.route" class="name">
                {{ item.name }}
              </router-link>
              <h4 v-else class="name">{{ item.name }}</h4>
              <p class="desc">{{ item.description }}</p>
            </div>
            <div
              v-if="query.filterTypeOfUnavailableDate === dateTypeMapping.DATE"
              class="col-2"
            >
              <sc-button
                variant="secondary"
                @click="handleClickRemoveUnavailableButton(item)"
                >นัดบริการได้</sc-button
              >
            </div>
          </div>
          <div class="text-end mt-4">
            <el-pagination
              :total="unavailableDateCount"
              :page-size="30"
              :current-page="query.page"
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import {
  Select as ElSelect,
  Option as ElOption,
  Input as ElInput,
  Radio as ElRadio,
  Pagination as ElPagination,
  Divider as ElDivider,
  CheckboxButton,
  CheckboxGroup
} from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import ProviderSelector from "@/lib/components/ProviderSelector";
import DatePicker from "@/lib/components/DatePicker";
import { DateTime } from "luxon";
import { baanRueJaiClient } from "@/dependencies";
import {
  daysOfWeek,
  timeOfDay,
  datesOfMonth,
  dateType,
  dateTypeMapping
} from "@/lib/mapper";
import { existValueAndEmptyString } from "@/lib/util";
import ServiceListItem from "../components/ServiceListItem";

export default {
  components: {
    PageWrapper,
    ServiceListItem,
    ScButton,
    ElSelect,
    ElOption,
    ElInput,
    ElRadio,
    ProviderSelector,
    ElPagination,
    ElDivider,
    DatePicker,
    "el-checkbox-group": CheckboxGroup,
    "el-checkbox-button": CheckboxButton
  },
  data() {
    const title = "รายการบริการ";
    const list = [];
    const unavailableDateList = [];
    const query = {
      name: null,
      providerId: null,
      filterType: null,
      filterTypeOfUnavailableDate: null,
    };
    const selectedProvider = null;
    const total = 0;
    const queryByUnavailableDate = {
      unavailableWorkdaysInMonth: [],
      unavailableTimes: [],
      unavailableWorkdaysInWeek: [],
      unavailableDate: null
    };

    const dateOfMonth = datesOfMonth.map((date) => date.toLocaleString());

    return {
      title,
      list,
      unavailableDateList,
      query,
      selectedProvider,
      total,
      daysOfWeek,
      timeOfDay,
      dateOfMonth,
      dateType,
      dateTypeMapping,
      queryByUnavailableDate,
      filterToType: {
        UNAVAILABLE: "unavailable",
        NORMAL: "normal"
      },
      unavailableDateCount: 0
    };
  },
  computed: {
    totalCount() {
      if (this.total === 0) {
        return "ไม่พบข้อมูล";
      }

      const limit = 30;
      const currentTotalItem = this.list.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = this.query.page;
      const endNum = isLastPage ? this.total : currentPage * limit;
      const startNum = (isLastPage ? limit * currentPage - limit : endNum - limit) + 1;

      return `แสดงผล ${startNum.toLocaleString()} - ${endNum.toLocaleString()} จากทั้งหมด ${this.total.toLocaleString()}`;
    }
  },
  watch: {
    "$route.query": async function watchRouteQuery() {
      this.setupQuery();
      await this.setupData();
    }
  },
  created() {
    this.setup();
  },
  methods: {
    mapNormalService(service) {
      const {
        id,
        name,
        short_description: shortDescription,
        description,
        icon_url: iconUrl,
      } = service;
      const provider = {
        ...service.provider,
        logoUrl: service.provider.logo_url,
      };
      const route = { name: "ServiceDetailPage", params: { id } };

      return {
        id,
        iconUrl,
        name,
        shortDescription,
        description,
        provider,
        route,
      };
    },
    setup() {
      this.setupQuery();
      this.setupData();
    },
    setupQuery() {
      const routeQuery = this.$route.query;

      const parsedPage = parseInt(routeQuery.page, 10) || 1;
      const page = parsedPage > 0 ? parsedPage : 1;
      const name = routeQuery.name ? routeQuery.name.trim() : null;

      this.query = {
        name: name || null,
        providerId: routeQuery.providerId || null,
        filterType: routeQuery.filterType || this.filterToType.NORMAL,
        page,
        filterTypeOfUnavailableDate:
          routeQuery.filterTypeOfUnavailableDate || null
      };

      if (
        existValueAndEmptyString(this.query.filterTypeOfUnavailableDate) &&
        existValueAndEmptyString(this.queryByUnavailableDate)
      ) {
        const {filterTypeOfUnavailableDate} = this.query;

        if (
          filterTypeOfUnavailableDate === this.dateTypeMapping.TIME &&
          existValueAndEmptyString(routeQuery.unavailableTimes)
        ) {
          this.queryByUnavailableDate = {
            ...this.queryByUnavailableDate,
            unavailableTimes: routeQuery.unavailableTimes.split(","),
          };
        } else if (
          filterTypeOfUnavailableDate === this.dateTypeMapping.DATE &&
          existValueAndEmptyString(routeQuery.unavailableDate)
        ) {
          this.queryByUnavailableDate = {
            ...this.queryByUnavailableDate,
            unavailableDate: DateTime.fromISO(routeQuery.unavailableDate),
          };
        } else if (
          filterTypeOfUnavailableDate === this.dateTypeMapping.WEEK &&
          existValueAndEmptyString(routeQuery.unavailableWorkdaysInWeek)
        ) {
          this.queryByUnavailableDate = {
            ...this.queryByUnavailableDate,
            unavailableWorkdaysInWeek:
              routeQuery.unavailableWorkdaysInWeek.split(","),
          };
        } else if (
          filterTypeOfUnavailableDate === this.dateTypeMapping.MONTH &&
          existValueAndEmptyString(routeQuery.unavailableWorkdaysInMonth)
        ) {
          this.queryByUnavailableDate = {
            ...this.queryByUnavailableDate,
            unavailableWorkdaysInMonth:
              routeQuery.unavailableWorkdaysInMonth.split(","),
          };
        }
      }
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      if (this.query.filterType === this.filterToType.NORMAL) {
        const { count, services } = await this.fetchList();

        this.total = count;
        this.list = services.map((service) => this.mapNormalService(service));
      } else if (this.query.filterType === this.filterToType.UNAVAILABLE) {
        const { services, count } = await this.fetchList();

        this.unavailableDateCount = count;
        this.unavailableDateList = services.map((service) => {
          const {
            id,
            name: serviceName,
            short_description: shortDescription,
            description,
            icon: iconUrl,
            unavailable_date_times: unavailableDateTimes,
            unavailable_times: unavailableTimesVal,
            unavailable_workdays_in_month: unavailableWorkdaysInMonth,
            unavailable_workdays_in_week: unavailableWorkdaysInWeek,
          } = service;
          const route = { name: "ServiceDetailPage", params: { id } };

          return {
            id,
            iconUrl,
            name: serviceName,
            shortDescription,
            description,
            route,
            unavailableDateTimes,
            unavailableTimesVal,
            unavailableWorkdaysInMonth,
            unavailableWorkdaysInWeek,
          };
        });
      }
    },

    async fetchList() {
      if (this.query.filterType === this.filterToType.NORMAL) {
        try {
          const response = await baanRueJaiClient.admin.subscriptions.services.search(
            this.query
          );
          return response.data.result;
        } catch (_err) {
          return { count: 0, services: [] };
        }
      }

      if (this.query.filterType === this.filterToType.UNAVAILABLE) {
        const queryType = this.query.filterTypeOfUnavailableDate;
        const take = 30;

        const queryUnavailableDate = this.queryByUnavailableDate;
        let queryString = "";
        if (
          this.checkExistValueAndEmptyArray(
            queryUnavailableDate.unavailableWorkdaysInMonth
          )
        ) {
          queryString = queryUnavailableDate.unavailableWorkdaysInMonth.join(",");
        } else if (
          this.checkExistValueAndEmptyArray(
            queryUnavailableDate.unavailableTimes
          )
        ) {
          queryString = queryUnavailableDate.unavailableTimes.join(",");
        } else if (
          this.checkExistValueAndEmptyArray(
            queryUnavailableDate.unavailableWorkdaysInWeek
          )
        ) {
          queryString = queryUnavailableDate.unavailableWorkdaysInWeek.join(",");
        } else if (
          existValueAndEmptyString(queryUnavailableDate.unavailableDate)
        ) {
          queryString = queryUnavailableDate.unavailableDate.toISO();
        }

        const params = {
          queryType,
          take,
          queryString,
          page: this.query.page || 1,
        };

        try {
          const dateFilterData =
            await baanRueJaiClient.admin.subscriptions.services.searchWithUnavailableDate(
              params
            );
          return dateFilterData.data.result;
        } catch (_err) {
          return { count: 0, services: [] };
        }
      }

      return { count: 0, services: [] };
    },
    async handleClickSearchButton() {
      if (
        this.query.filterType === this.filterToType.UNAVAILABLE
        && !existValueAndEmptyString(this.query.filterTypeOfUnavailableDate)
      ) {
        this.$message.error('กรุณาเลือก ประเภทวันที่ไม่สามารถนัดหมายบริการ');
        return
      }

      const name = this.query.name ? this.query.name.trim() : undefined;

      const query = {
        name: name || undefined,
        providerId: this.selectedProvider
          ? this.selectedProvider.id
          : undefined,
        unavailableDate:
          this.queryByUnavailableDate.unavailableDate !== null
            ? this.queryByUnavailableDate.unavailableDate.toISO()
            : undefined,
        filterType: this.query.filterType,
        unavailableTimes: this.existValueToQuery(
          this.queryByUnavailableDate.unavailableTimes,
          true
        ),
        unavailableWorkdaysInWeek: this.existValueToQuery(
          this.queryByUnavailableDate.unavailableWorkdaysInWeek,
          true
        ),
        unavailableWorkdaysInMonth: this.existValueToQuery(
          this.queryByUnavailableDate.unavailableWorkdaysInMonth,
          true
        ),
        filterTypeOfUnavailableDate: this.query.filterTypeOfUnavailableDate
      };

      this.$router.replace({ ...this.$route, query });
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    },
    async handleClickRemoveUnavailableButton(service) {
      if (!this.queryByUnavailableDate.unavailableDate) {
        this.$message.error('เลือกประเภทวันผิด');
        return;
      }

      const unavailableDate = this.queryByUnavailableDate.unavailableDate
        .minus({ days: 1 })
        .toISO()
        .slice(0, 10);

      const filteredDateTimes = service.unavailableDateTimes.filter(
        (dateTimeEntry) =>
          !dateTimeEntry.includes(unavailableDate)
      );

      const data = {
        unavailableDateTimes: filteredDateTimes,
        unavailableTimes: service.unavailableTimesVal,
        unavailableWorkdaysInMonth: service.unavailableWorkdaysInMonth,
        unavailableWorkdaysInWeek: service.unavailableWorkdaysInWeek,
      };

      try {
        await baanRueJaiClient.admin.subscriptions.services.putWorkdays(
          service.id,
          data
        );

        this.$message.success("บันทึกเรียบร้อย");
        this.setupList();
      } catch (error) {
        this.$message.error("ไม่สามารถเลือกวันที่ไม่สามารถนัดหมายได้");
      }
    },
    handleChangeFilterType() {
      const { filterType } = this.query;

      this.query = {
        name: null,
        providerId: null,
        filterType,
        filterTypeOfUnavailableDate: null,
      };
      this.selectedProvider = null;

      this.setEmptyFilterByUnavailableDate();
    },
    async handleChangeFilterTypeOfUnavailableDate() {
      this.setEmptyFilterByUnavailableDate();

      await this.setupList();
    },
    setEmptyFilterByUnavailableDate() {
      this.queryByUnavailableDate = {
        unavailableWorkdaysInMonth: [],
        unavailableTimes: [],
        unavailableWorkdaysInWeek: [],
        unavailableDate: null,
      };
    },
    existValueToQuery(value, isJoinString = false, typeToEmpty = undefined) {
      if (isJoinString === true) {
        return existValueAndEmptyString(value) && value.length > 0
          ? value.join(",")
          : typeToEmpty;
      }

      return existValueAndEmptyString(value) && value.length > 0
        ? value
        : typeToEmpty;
    },
    handleChangeSelectedUnavailableDate(selectUnavailableDate) {
      this.queryByUnavailableDate.unavailableDate = selectUnavailableDate;
    },
    checkExistValueAndEmptyArray(value) {
      return existValueAndEmptyString(value) && value.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 64px;

.header {
  display: flex;
  flex-flow: row nowrap;
  padding: 30px;
  border-bottom: $border;
  justify-content: space-between;
  background: #f9f9f9;
}
.wrapper {
  padding: ($space / 2) $space;
}
.service-list-item {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;

  align-items: flex-start;

  border-bottom: $border;
  padding: ($space / 2) $space;

  > .icon {
    margin-top: 5px;
    display: block;

    border-radius: 8px;
    width: $logoSize;
    height: $logoSize;
    flex: 0 0 $logoSize;
  }

  > .icon + .meta {
    padding-left: $space;
  }

  > .meta {
    display: block;

    flex-grow: 1;
  }
}

.filter-form {
  background-color: #f9f9f9;
}

.meta {
  min-width: 0;

  > .name {
    display: inline-block;
    font-size: 1rem;

    &:hover {
      color: black;
    }
  }

  > .desc {
    overflow: hidden;
    height: 23px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > .provider {
    margin-top: 5px;
  }
}

.meta p {
  line-height: 1.6;
  font-size: 0.9rem;
  color: #777;
}

.search-service {
  font-size: 0.9rem;
}

.date-calendar {
  .el-checkbox-group {
    display: grid;

    grid-template-columns: repeat(6, 40px);
    padding-right: 10px;
  }
}
</style>
